export { MyMerits } from './MyMerits/MyMerits';
export { ActivePoints } from './ActivePoints/ActivePoints';
export { Pledges } from './Pledges/Pledges';
export { Contacts } from './Contacts/Contacts';
export { Interviews } from './Interviews/Interviews';
export { Settings } from './Settings/Settings';



// WEBPACK FOOTER //
// ./src/containers/PledgeApp/components/index.js